/* eslint-disable import/no-anonymous-default-export */
import { Pagination, styled, Table, TableCell } from '@mui/material';

import theme from 'core/ThemeConstants';

const TableHeadCell = styled(TableCell)(() => ({
  fontWeight: 600,
  fontSize: '12px',
  backgroundColor: theme.black.default,
  color: theme.white.default,
}));

const TableBodyCell = styled(TableCell)(() => ({
  small: {
    fontWeight: 500,
    fontSize: '12px',
    color: theme.black.default,
  },
  borderColor: theme.grey.default,
}));

const TableGrid = styled(Table)(() => ({
  boxShadow: theme.boxShadows.default,
  td: {
    padding: '5px',
  },
  'td + td': {
    borderLeft: `1px solid ${theme.grey.default}`,
  },
  'th + th': {
    borderLeft: `1px solid ${theme.grey.default}`,
  },
  'tbody tr': {
    transition: 'all 0.3s',
  },
  'tbody tr:hover': {
    backgroundColor: theme.grey.default,
  },
}));

const TablePagination = styled(Pagination)(({ theme }) => ({
  '& .MuiPaginationItem-root': {
    fontWeight: 600,
  },
  '& .MuiPaginationItem-page:hover': {
    color: '#fff',
    backgroundColor: theme.palette.success.main,
  },
  '& .MuiPaginationItem-page.Mui-selected': {
    color: theme.palette.success.main,
    borderRadius: '4px',
    border: `1px solid ${theme.palette.success.main}`,
    backgroundColor: 'transparent',
  },
  '& .MuiPaginationItem-previousNext': {
    color: theme.palette.success.main,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}));

export default { TableGrid, TablePagination, TableHeadCell, TableBodyCell };
